export default {
  GET_MOBILEVIDEOINFO: '/api/test/invigilate/getMobileVideoInfo',            // H5端获取用户推流信息

  INV_GET_MOBILEVIDEOINFO: '/api/test/invigilate/getMobileVideoInfo',            // H5端获取用户推流信息

  UPDATEVIDEOSTATUS: '/api/test/invigilate/updateVideoStatus',               // 推流状态修改

  INV_UPDATEVIDEOSTATUS: '/api/test/invigilate/updateVideoStatus',               // 推流状态修改

  EXAMFREELOGIN: '/api/user/examFreeLogin',                               // H5静默登录接口

  SUBMITHEART: '/api/test/invigilate/submitHeart',                            // H5心跳接口

  INV_SUBMITHEART: '/api/test/invigilate/submitHeart',                            // H5心跳接口

  PROCTOR_GETUSERSING: '/api/test/invigilate/getUserSig',                     // 获取签名

  REPROT_LOG_RECORD: '/api/common/reportLogRecord',                         // 上报日志

  PROCTOR_SAVEEXAMTRANSACTION: '/api/test/paper/saveExamTransaction',         // 上传用户行为

  INV_PROCTOR_SAVEEXAMTRANSACTION: '/api/test/invigilate/saveExamTransaction',         // 上传用户行为

  EQUIQMENT_UPDATEMOBILESTATUS: '/api/test/invigilate/updateMobileStatus',        // 手机扫码连接状态更新

  PROCTOR_GETOSSINFO: '/api/test/invigilate/getOssInfo'                         // 获取阿里云配置
}



// WEBPACK FOOTER //
// ./src/assets/api/common/proctor.js